<!--used to add email or domain to blacklist
component used in BlackList.vue
In (ui) System Settings-> WhiteList/BlackList-> scroll down (add blacklist item)
-->
<template>
  <v-row>
    <v-col>
      <div flat class="settings">
        <v-form ref="formW" @submit.prevent="addItem">
          <v-container fluid>
            <v-row class="mx-0">
              <h2 class="white--text">{{ addHead }}</h2>
            </v-row>
            <v-row>
              <v-col sm="3">
                <v-select
                  :items="optionsSet2"
                  solo
                  flat
                  v-model="selectItemType"
                  append-icon="keyboard_arrow_down"
                  item-value="key"
                  class="cursorPointer primarygreen--text"
                  background-color="#fff !important"
                  item-text="value"
                  height="56px"
                  label="Select Item Type"
                ></v-select>
              </v-col>
              <v-col sm="3">
                <v-select
                  :items="optionsSet1"
                  solo
                  flat
                  v-model="selectBlackListType"
                  append-icon="keyboard_arrow_down"
                  item-value="key"
                  class="cursorPointer primarygreen--text"
                  background-color="#fff !important"
                  item-text="value"
                  height="56px"
                  label="Select BlackList Category"
                ></v-select>
              </v-col>
              <v-col sm="3">
                <v-text-field
                  class="primarygreen--text"
                  autocomplete="off"
                  v-model="addValue"
                  single-line
                  solo
                  filled
                  flat
                  :label="this.selectItemType === 'email' ? 'Enter an email' : 'Enter a domain'"
                  tile
                  height="56px"
                  background-color="#fff !important"
                  @keyup.enter="addItem"
                ></v-text-field>
              </v-col>
              <v-col
                class="text-right"
                :class="[selectItemType === 'email' ? 'col-sm-3' : 'col-sm-3']"
                align="center"
              >
                <v-btn
                  color="white"
                  tile
                  large
                  height="56px"
                  width="152px"
                  max-width="100%"
                  @click="addItem"
                  class="primarygreen--text font-weight-black text-uppercase"
                >Add</v-btn>
                <v-btn
                  color="white"
                  height="56px"
                  width="100%"
                  @click="addItem"
                  class="primarygreen--text"
                  v-if="saveFailed"
                >Try Again</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: [
    'addHead',
    'optionsSet1',
    'optionsSet2',
    'clear',
    'selectedListType',
    'selectedType'
  ],
  data() {
    return {
      addValue: '',
      saveFailed: false,
      selectBlackListType: this.selectedListType,
      selectItemType: this.selectedType
    };
  },
  methods: {
    // add item to blacklist
    addItem() {
      if (this.selectBlackListType !== '' && this.selectItemType !== '') {
        if (this.addValue !== '') {
          if (this.selectItemType === 'email') {
            if (this.emailValidate(this.addValue)) {
              let data = {
                value: this.addValue,
                categorySet1: this.selectBlackListType,
                categorySet2: this.selectItemType
              };
              this.$emit('dataSubmit', data);
            } else {
              this.snackbar('error', this.$message.INVALID_EMAIL1);
            }
          } else {
            let data = {
              value: this.addValue,
              categorySet1: this.selectBlackListType,
              categorySet2: this.selectItemType
            };
            this.$emit('dataSubmit', data);
          }
        } else {
          this.selectItemType === 'email'
            ? this.snackbar('error', this.$message.EMAIL_EMPTY)
            : this.snackbar('error', this.$message.DOMAIN_EMPTY);
        }
      } else {
        this.snackbar('error', `${this.$message.SELECT_FIELD} category`);
      }
    }
  },
  watch: {
    clear: function(value) {
      if (value) {
        this.addValue = '';
        this.selectBlackListType = this.selectedListType;
        this.selectItemType = this.selectedType;
      }
    }
  }
};
</script>
